import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import "./AuthGateModal.css";

export default function AuthGateModal({
  isOpen,
  onClose,
  nextPath,
  nextState,
  heading = "view on the platform",
  subtext = ""
}) {
  const { user } = useAuth();
  const navigate = useNavigate();

useEffect(() => {
  if (isOpen && user) {

    onClose();

    if (nextPath) {
      navigate(nextPath, {
        state: nextState
      });
    }

  }
}, [
  user,
  isOpen,
  nextPath,
  nextState,
  onClose,
  navigate
]);

  if (!isOpen) return null;

  return (
    <div className="authgate-overlay">
      <div className="authgate-card">
        <button className="authgate-close" onClick={onClose} aria-label="Close">×</button>
        <h3>{heading}</h3>

{subtext && (
  <p className="authgate-subtext">
    {subtext}
  </p>
)}
        <p className="authgate-subtext"> </p>
        <div className="authgate-actions">
          <button
            onClick={() =>
              navigate("/new", {
                state: { postSignupRedirect: { path: nextPath, state: nextState } },
              })
            }
          >
            sign up
          </button>
          <button
            onClick={() =>
              navigate("/returning", {
                state: { postLoginRedirect: { path: nextPath, state: nextState } },
              })
            }
          >
            log in
          </button>
        </div>
      </div>
    </div>
  );
}
